import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { CCFeedResponse } from "../api/types";

/**
 * Сводка фида crypto-console по активу (ADR-0039).
 *
 * Опрос REST, а не сокет, по тому же доводу, что у плотности биржи и индекса:
 * сводка — СОСТОЯНИЕ («что на биржах сейчас»), а не поток, где важен порядок,
 * и заводить ради прибора тип сообщения значило бы трогать контракт раздачи.
 */
export function ccfeedKey(asset: string) {
  return ["ccfeed", asset] as const;
}

/**
 * Раз в секунду — каденция источника: трейдер перекладывает сводку в Redis
 * ровно с этим шагом, и чаще спрашивать попросту нечего.
 */
const POLL_MS = 1000;

export function useCCFeed(asset: string) {
  return useQuery<CCFeedResponse>({
    queryKey: ccfeedKey(asset),
    queryFn: () => api.ccfeed(asset),
    enabled: Boolean(asset),
    refetchInterval: POLL_MS,
    // В фоновой вкладке не опрашиваем: панель — прибор для глаз, а секундный
    // опрос окна, на которое никто не смотрит, — круг ни за чем.
    refetchIntervalInBackground: false,
  });
}
